// extracted by mini-css-extract-plugin
module.exports = {"img":"iconWithText_img__1MEkB","text":"iconWithText_text__38TEi","wrapper":"iconWithText_wrapper__3rk_6"};